import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import MDBox from "../../MDBox";
import MDInput from "../../MDInput";
import MDTypography from "../../MDTypography";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

import ManualParams from "./ManualParams.js";
import ActivityParams from "./ActivityParams.js";

function MilestoneEdition({ milestone, position, onChange, onClose }) {
  const isValid = () => true;

  return (
    <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <MDTypography variant="h5" component="div" sx={{ mb: 1.5 }}>
          Étape {position}
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDBox>
              <MDInput
                type="text"
                label="Description"
                name="description"
                multiline
                rows={4}
                value={milestone.description || ""}
                onChange={(e) => onChange({ ...milestone, description: e.target.value })}
                fullWidth
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6}>
            <MDBox>
              <FormControl fullWidth>
                <InputLabel id="mode-label">Mode de validation</InputLabel>
                <Select
                  labelId="mode-label"
                  id="mode"
                  fullWidth
                  value={milestone.validation_mode || ""}
                  label="Mode de validation"
                  onChange={(e) => onChange({ ...milestone, validation_mode: e.target.value })}
                >
                  <MenuItem value={"parent"}>Par le parent</MenuItem>
                  <MenuItem value={"manual"}>Manuelle</MenuItem>
                  <MenuItem value={"autonomous"}>Autonome</MenuItem>
                  <MenuItem value={"activity"}>Activité</MenuItem>
                </Select>
              </FormControl>
              <MDTypography
                variant="caption"
                component="div"
                sx={{ fontStyle: "italic", lineHeight: "1.5", mt: 0.25 }}
              >
                {milestone.validation_mode === "parent" &&
                  "Validation par le parent. Votre enfant pourra vous notifier afin de penser à valider l'étape."}
                {milestone.validation_mode === "manual" &&
                  "Validation manuelle. L'enfant soumettra son étape lorsque celle-ci sera terminée, et pourra founir des preuves si demandé."}
                {milestone.validation_mode === "autonomous" &&
                  "Validation autonome. L'enfant pourra valider son étape tout seul."}
                {milestone.validation_mode === "activity" &&
                  "Validation automatique à l'aide d'une activité personnalisée."}
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6}>
            <MDBox>
              <MDInput
                type="date"
                label="À terminer pour le"
                name="date"
                InputLabelProps={{ shrink: true }}
                value={milestone.date || null}
                onChange={(e) => onChange({ ...milestone, date: e.target.value })}
                fullWidth
              />
              <MDTypography
                variant="caption"
                sx={{ fontStyle: "italic", lineHeight: "1.5", mt: 0.25 }}
                component="div"
              >
                Cette date permettra le rappel et le suivi des étapes pour l&apos;enfant.
              </MDTypography>
            </MDBox>
          </Grid>
          {milestone.validation_mode === "manual" && (
            <Grid item xs={12}>
              <MDBox>
                <ManualParams
                  params={milestone.validation_params || {}}
                  onChange={(params) => onChange({ ...milestone, validation_params: params })}
                />
              </MDBox>
            </Grid>
          )}
          {milestone.validation_mode === "activity" && (
            <Grid item xs={12}>
              <MDBox>
                <ActivityParams
                  params={milestone.validation_params || {}}
                  onChange={(params) => onChange({ ...milestone, validation_params: params })}
                />
              </MDBox>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button disabled={!isValid()} color="info" onClick={onClose}>
          Valider
        </Button>
      </DialogActions>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
    </Dialog>
  );
}
MilestoneEdition.propTypes = {
  milestone: PropTypes.object,
  position: PropTypes.number,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
};

export default MilestoneEdition;
